import React from 'react';
import { Label } from '@progress/kendo-react-labels';
import { TextArea } from '@progress/kendo-react-inputs';

export const NoteInput: React.FC<{
  label: string;
  value: string;
  placeholder: string;
  isDisabled: boolean;
  handleInputChange: (value: string) => void;
}> = ({ value, label, isDisabled, placeholder, handleInputChange }) => {
  const counterColorClass = React.useMemo(() => {
    if (value.length < 250) return 'text-success';
    if (value.length < 500) return 'text-warning';

    return 'text-danger';
  }, [value.length]);

  React.useEffect(() => {
    if (value.length < 500) return;

    handleInputChange(value.substring(0, 500));
  }, [value]);

  return (
    <div className={'d-flex flex-column h-100'}>
      <div className={'d-flex align-items-center justify-content-between'}>
        <Label
          style={{
            fontSize: '12px'
          }}>
          {label}
        </Label>

        <span className={counterColorClass}>{500 - value.length}</span>
      </div>

      <TextArea
        className={'h-100'}
        placeholder={placeholder}
        value={value}
        onChange={(e) => handleInputChange(e.value)}
        disabled={isDisabled}
      />
    </div>
  );
};
